<mat-card class="cardWithShadow" [attr.dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
    <mat-card-content>
        <ng-container *ngIf="loading">
            <div class="justify-content-center align-items-center d-flex" *ngIf="loading">
                <mat-spinner></mat-spinner>
            </div>
        </ng-container>

        <ng-container *ngIf="!loading">
            <form [formGroup]="contactDetailForm">
                <div class="row">
                    <!-- Contact Type -->
                    <div class="col-sm-2 d-flex align-items-center">
                        <mat-label class="f-s-14 f-w-600 d-block m-b-16">{{ 'Contact.Detail.ContactType' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-select formControlName="contactTypeId"
                                placeholder="{{ 'Contact.Detail.ContactType' | translate}}">
                                <mat-option *ngFor="let type of contactTypeList" [value]="type.id">
                                    {{ isArabic && type.nameAr? type.nameAr :type.nameEn}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="contactDetailForm.controls['contactTypeId'].invalid && contactDetailForm.controls['contactTypeId'].touched">
                                {{ 'Contact.Detail.ContactType' | translate }} {{'Shared.REQUIRED' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Contact Value -->
                    <div class="col-sm-2 d-flex align-items-center">
                        <mat-label class="f-s-14 f-w-600 d-block m-b-16">{{ 'Contact.Detail.Value' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <input matInput formControlName="contactValue"
                                [placeholder]="'Contact.Detail.Value' | translate" type="text" required />
                            <mat-error
                                *ngIf="contactDetailForm.controls['contactValue'].invalid && contactDetailForm.controls['contactValue'].touched">
                                {{ 'Contact.Detail.Value' | translate }} {{'Shared.REQUIRED' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <!-- Order No -->
                    <div class="col-sm-2 d-flex align-items-center">
                        <mat-label class="f-s-14 f-w-600 d-block m-b-16">{{ 'Contact.Detail.OrderNo' |
                            translate}}</mat-label>
                    </div>
                    <div class="col-sm-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <input matInput formControlName="orderNo"
                                [placeholder]="'Contact.Detail.OrderNo' | translate" type="text" required />
                            <mat-error
                                *ngIf="contactDetailForm.controls['orderNo'].invalid && contactDetailForm.controls['orderNo'].touched">
                                {{ 'Contact.Detail.OrderNo' | translate }} {{'Shared.REQUIRED' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Is Active / Status -->
                    <div class=" align-items-center mb-3 col-sm-6">
                        <div class=" d-flex align-items-center">
                            <mat-slide-toggle formControlName="isActive" color="primary"
                                (change)="onToggleChange($event, contactDetailForm.get('isActive')?.value)"
                                [checked]="contactDetailForm.get('isActive')?.value">
                                <span class="f-s-14 f-w-600">{{ 'Shared.IsActive' | translate }}</span>
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>

                <div class="row ">
                    <div class="col-sm-12 d-flex">
                        <button (click)="onSubmit() " mat-flat-button style="margin-top: 20px;" [disabled]="
                                                                !(
                                                                    contactDetailForm?.get('contactValue')?.value &&
                                                                    contactDetailForm?.get('orderNo')?.value &&
                                                                    contactDetailForm?.get('contactTypeId')?.value 
                                                                 )
                                                                      ">
                            {{(action=='Update'? 'Shared.Update': 'Shared.Add') | translate }}
                        </button>
                        <button (click)="cancelAddOrUpdate() " mat-button style="margin-top: 20px;" class="m-x-10"
                            [disabled]="
    !(
      contactDetailForm?.get('contactValue')?.value ||
      contactDetailForm?.get('orderNo')?.value ||
      contactDetailForm?.get('contactTypeId')?.value 
    )
  ">
                            {{ 'Shared.Cancel' | translate }}
                        </button>
                        <button (click)="navigateToAmenityPage()" mat-stroked-button color="success" type="button"
                            style="margin-top: 20px;" class="m-x-10">
                            {{ backBtnName | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-container>
    </mat-card-content>
</mat-card>